import React,{Component} from "react";
import Header from "../components/Header";
import Contact_form from "../forms/Contact_form";



class Contact extends React.Component{
    render(){
        return(
            <div>

                   {/*<!-- Header Container -->*/}
                   <Header contact="current"/>
                  {/*<!-- Header Container / End -->*/}

                  {/*<!-- Titlebar -->*/}
                  <div className="parallax titlebar" style={{backgroundImage:"url(assets/images/home-parallax-3.jpg)", backgroundAttachment:"fixed", backgroundSize:"1838px 1160.24px", backgroundPosition:"50% -550.067px"}}>
                    <div class="parallax-overlay" style={{backgroundColor:"rgb(48, 48, 48)", opacity: "0.8"}}></div>
                    <div id="titlebar">
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <h2>Contact Us</h2>
                            {/*<!-- Breadcrumbs -->*/}
                            <nav id="breadcrumbs">
                              <ul>
                                <li><a href="index.html">Home</a></li>
                                <li>Contact Us</li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/*<!-- Container / Start -->*/}
                  <div className="container">
                    <div className="row">  
                      {/* 
                	    <div className="col-md-12">
                        <div className="utf-contact-map margin-bottom-50">
                          <div className="utf-google-map-container">
                			      <div id="propertyMap" data-latitude="48.8566" data-longitude="2.3522" data-map-icon="im im-icon-Hamburger"></div>
                			        <a href="#" id="streetView">Street View</a> 
                		        </div>
                          </div>
                      </div>
                      */}	
                      {/*<!-- Contact Details -->*/}
                      <div className="col-md-4">
                        <div className="utf-boxed-list-headline-item">
                            <h3><i className="icon-feather-map"></i> Office Address</h3>
                        </div>
                        {/*<!-- Contact Details -->*/}
                        <div className="utf-contact-location-info-aera sidebar-textbox margin-bottom-40">
                          <ul className="contact-details">
                            <li><i className="icon-feather-smartphone"></i> <strong>Phone Number:</strong> <span>(+21) 124 123 4546</span></li>
                            <li><i className="icon-material-outline-email"></i> <strong>Email Address:</strong> <span><a href="#">info@example.com</a></span></li>
                			<li><i className="icon-feather-globe"></i> <strong>Website:</strong> <span>www.example.com</span></li>
                			<li><i className="icon-feather-map-pin"></i> <strong>Address:</strong> <span>3241, Lorem ipsum dolor sit amet, consectetur adipiscing elit Proin fermentum condimentum mauris.</span></li>            
                          </ul>
                        </div>
                      </div>
                      
                      {/*<!-- Contact Form Section-->*/}
                      <div className="col-md-8">
                        <section id="contact">
                		  <div className="utf-boxed-list-headline-item">
                            <h3><i className="icon-feather-layers"></i> Contact Form</h3>
                          </div>
                		  <div className="utf-contact-form-item">
                             {/*<!-- Contact Form -->*/}
                                   <Contact_form/>
                             {/*<!-- Contact Form  END-->*/}
                		    </div>	  
                        </section>
                      </div>
                      {/*<!-- Contact Form Section/ End -->*/}       
                    </div>
                  </div>
                  {/*<!-- Container / End -->*/} 
                  

            </div>
        )
    }
}




export default Contact;